import styled from 'styled-components';

export const StatsStrip = styled.div`
  max-width: 96rem;
  margin: 0 auto;
  padding: ${({ theme }) => `0 ${theme.spacing.lg} 4.8rem`};
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${({ theme }) => theme.spacing.md};

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    padding: ${({ theme }) => `0 ${theme.spacing.lg} 3.2rem`};
    gap: ${({ theme }) => theme.spacing.sm};

    & > :last-child {
      grid-column: 1 / -1;
    }
  }
`;

export const StatCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.4rem;
  padding: ${({ theme }) => `${theme.spacing.lg} ${theme.spacing.md}`};
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1.6rem;

  @media (max-width: 768px) {
    padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.sm}`};
  }
`;

export const StatIcon = styled.div`
  font-size: 2rem;
  margin-bottom: 0.4rem;
`;

export const StatNumber = styled.span`
  font-size: 2.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  display: block;
  line-height: 1.1;
`;

export const StatLabel = styled.span`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  margin-top: 0.4rem;
  font-weight: 600;
`;
